var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRentcarPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 179,
    viewBox: "0 0 261 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_512_35117)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 179,
    rx: 8,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.922 76.5784C246.922 76.3319 247.956 75.099 248.163 74.8524L247.956 73.6195C248.301 73.0442 249.032 71.8442 249.198 71.6469C249.405 71.4004 250.439 71.6469 250.646 71.6469C250.853 71.6469 251.68 72.6332 252.094 72.8798C252.508 73.1264 252.922 75.099 252.922 75.5921C252.922 76.0853 252.922 77.5648 252.715 77.8113C252.508 78.0579 251.887 79.0442 251.68 79.2908C251.474 79.5374 250.646 79.5374 250.439 79.5374C250.232 79.5374 248.991 79.2908 248.784 79.2908C248.618 79.2908 247.749 78.4689 247.336 78.0579C247.198 77.6469 246.922 76.7757 246.922 76.5784Z",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.922 119.578C128.922 119.332 130.129 118.099 130.37 117.852L130.129 116.62C130.531 116.044 131.384 114.844 131.577 114.647C131.818 114.4 133.025 114.647 133.267 114.647C133.508 114.647 134.474 115.633 134.956 115.88C135.439 116.126 135.922 118.099 135.922 118.592C135.922 119.085 135.922 120.565 135.68 120.811C135.439 121.058 134.715 122.044 134.474 122.291C134.232 122.537 133.267 122.537 133.025 122.537C132.784 122.537 131.336 122.291 131.094 122.291C130.901 122.291 129.887 121.469 129.405 121.058C129.244 120.647 128.922 119.776 128.922 119.578Z",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.805 235.521L237.772 234.908L245.334 209.84L230.43 205.345L222.869 230.412L220.836 229.799L228.398 204.732L212.815 200.031L205.253 225.098L203.221 224.485L210.782 199.418L195.199 194.718L187.638 219.785L185.606 219.172L216.872 115.517L203.323 111.429L172.056 215.085L170.024 214.472L170.149 214.058L151.282 198.193L148.344 207.932L146.312 207.319L149.513 196.706L134.186 183.817L128.7 202.006L126.667 201.393L132.185 183.101L110.505 176.561L104.987 194.853L102.955 194.24L108.473 175.948L109.086 173.916L118.486 142.752L118.484 142.751L119.097 140.719L119.099 140.719L128.499 109.555L128.496 109.554L129.109 107.522L129.112 107.523L134.222 90.5855L134.218 90.5845L134.831 88.552L134.835 88.5531L142.192 64.1625L142.192 64.1625L142.805 62.13L142.805 62.1301L150.162 37.7407L150.161 37.7405L150.774 35.7081L150.775 35.7083L158.336 10.6419L158.333 10.6409L158.946 8.60844L158.949 8.60939L162.219 -2.23061L162.216 -2.23132L162.829 -4.2638L162.832 -4.26309L167.736 -20.5227L167.733 -20.5235L168.347 -22.556L168.349 -22.5551L181.428 -65.9143L181.425 -65.9152L182.243 -68.6252L264.896 -43.6934L264.079 -40.9835L207.173 -58.1486L197.773 -26.985L254.679 -9.8197L266.94 -50.4684L268.973 -49.8553L266.702 -42.3282L304.862 -10.2396L313.532 -19.5706L283.954 -44.4432L285.283 -46.024L314.94 -21.0856L321.072 -27.6855L322.585 -26.2796L306.444 -8.90867L317.613 0.483024L324.786 -7.23689L326.299 -5.83098L319.196 1.81396L322.809 4.85273L321.48 6.43351L317.788 3.32885L304.706 17.4076L314.509 25.651L313.18 27.2317L303.298 18.9225L290.143 33.0801L309.409 49.2812L308.08 50.862L298.224 42.5741L296 49.9496L305.283 52.75L304.67 54.7824L295.386 51.982L288.824 73.7377C290.193 74.5605 291.004 76.0847 290.919 77.6815L297.363 79.6252L296.766 81.6026L290.323 79.6591C289.505 81.0488 287.968 81.8734 286.357 81.7869L280.739 100.412C282.128 101.231 282.952 102.768 282.865 104.378L289.311 106.323L288.714 108.3L282.268 106.356C281.449 107.743 279.914 108.566 278.305 108.48L272.686 127.111C274.074 127.929 274.898 129.464 274.812 131.073L281.258 133.017L280.662 134.995L274.216 133.05C273.369 134.49 271.749 135.324 270.076 135.166L239.805 235.521ZM205.141 -58.7617L183.461 -65.3012L170.382 -21.9421L192.062 -15.4026L205.141 -58.7617ZM160.981 9.22246L164.251 -1.61754L185.931 4.92196L182.661 15.762L160.981 9.22246ZM200.833 9.41713L187.963 5.53504L184.694 16.375L241.6 33.5404L245.87 19.3846L215.572 -6.09354L193.481 -12.757L188.576 3.50257L201.446 7.38466L200.833 9.41713ZM164.864 -3.65001L186.544 2.88949L191.449 -13.3701L169.769 -19.9096L164.864 -3.65001ZM216.46 -8.04303L194.094 -14.7895L197.16 -24.9525L254.066 -7.78723L246.519 17.232L220.576 -4.58407L250.387 4.40824L251 2.37576L216.464 -8.04178L216.461 -8.04434L216.46 -8.04303ZM293.43 51.3918L286.874 73.1258C285.243 73.0161 283.68 73.843 282.851 75.2483L270.772 71.6046L278.25 46.8129L293.43 51.3918ZM270.175 73.582L282.254 77.2255C282.168 78.8351 282.992 80.3711 284.38 81.1898L278.762 99.8155C277.151 99.7293 275.614 100.554 274.796 101.944L262.719 98.3015L270.175 73.582ZM276.328 107.884L270.708 126.514C269.099 126.428 267.563 127.251 266.745 128.639L254.667 124.996L262.122 100.279L274.201 103.922C274.116 105.531 274.94 107.066 276.328 107.884ZM254.07 126.974L266.147 130.617C266.065 132.147 266.806 133.612 268.073 134.456L261.887 154.964L246.983 150.469L254.07 126.974ZM305.037 -7.39376L316.205 1.99793L303.123 16.0767L291.955 6.68501L305.037 -7.39376ZM290.547 8.19992L301.716 17.5916L288.561 31.7492L277.392 22.3575L290.547 8.19992ZM275.985 23.8724L287.153 33.2641L276.98 44.2125L261.44 39.525L275.985 23.8724ZM294.043 49.3593L279.182 44.8767L288.736 34.595L296.521 41.1421L294.043 49.3593ZM275.809 21.0266L262.125 9.51875L260.795 11.0995L274.402 22.5415L259.238 38.8608L243.632 34.1534L256.098 -7.17415L256.101 -7.17349L256.714 -9.20597L256.712 -9.20663L266.053 -40.1757L303.454 -8.7247L275.809 21.0266ZM180.162 180.862L170.798 211.906L151.931 196.04L161.295 164.997L180.162 180.862ZM159.527 163.51L150.163 194.553L134.869 181.693L134.803 181.772L144.199 150.621L159.527 163.51ZM144.818 148.571L144.881 148.496L160.176 161.357L169.512 130.406L154.185 117.517L144.818 148.571ZM161.945 162.845L180.811 178.71L190.148 147.758L171.281 131.893L161.945 162.845ZM201.291 110.816L190.797 145.606L171.93 129.74L179.611 104.277L201.291 110.816ZM177.579 103.664L170.161 128.253L154.867 115.392L154.803 115.467L159.966 98.3512L177.579 103.664ZM261.274 156.997L246.37 152.501L240.993 170.327L253.963 181.234L261.274 156.997ZM244.951 149.855L252.038 126.36L239.414 122.553C238.611 123.915 237.118 124.735 235.542 124.685L229.368 145.155L244.951 149.855ZM233.501 124.102L227.335 144.542L211.752 139.842L218.905 116.13L231.363 119.887C231.179 121.592 232.027 123.249 233.501 124.102ZM232.1 117.892C232.949 116.656 234.394 115.936 235.904 116.017L241.525 97.3834C240.157 96.575 239.338 95.0696 239.399 93.4844L226.875 89.7066L219.518 114.097L232.1 117.892ZM237.882 116.613L243.502 97.9822C245.112 98.0702 246.649 97.2471 247.469 95.8588L260.09 99.6658L252.634 124.383L240.009 120.575C240.094 118.966 239.27 117.431 237.882 116.613ZM239.997 91.4473L227.488 87.6741L234.845 63.2848L247.443 67.0848C247.486 68.5625 248.289 69.9362 249.575 70.6939L243.958 89.3175C242.349 89.2334 240.814 90.0584 239.997 91.4473ZM251.553 71.2895C253.163 71.375 254.699 70.55 255.517 69.1604L268.143 72.9689L260.686 97.6884L248.067 93.8819C248.154 92.2692 247.328 90.7299 245.936 89.9116L251.553 71.2895ZM256.112 67.1826C256.197 65.5748 255.374 64.0408 253.987 63.2226L260.524 41.5512L258.547 40.9548L252.01 62.6249C250.303 62.5326 248.679 63.4638 247.905 65.0067L235.458 61.2523L243.019 36.1859L276.217 46.1999L268.739 70.9915L256.112 67.1826ZM228.755 147.187L244.337 151.888L239.224 168.84L225.663 157.436L228.755 147.187ZM226.722 146.574L211.139 141.874L210.334 144.545L223.894 155.949L226.722 146.574ZM253.313 183.386L245.947 207.808L231.043 203.312L240.344 172.48L253.313 183.386ZM238.575 170.992L229.011 202.699L213.428 197.999L225.014 159.589L238.575 170.992ZM223.245 158.102L211.395 197.386L195.812 192.685L209.684 146.698L223.245 158.102ZM182.048 17.7944L160.368 11.2549L152.807 36.3213L174.487 42.8608L182.048 17.7944ZM184.08 18.4075L201.693 23.7202L194.132 48.7866L176.519 43.4739L184.08 18.4075ZM203.725 24.3332L196.164 49.3996L217.844 55.9391L225.405 30.8727L203.725 24.3332ZM227.438 31.4858L240.987 35.5728L233.426 60.6392L219.876 56.5522L227.438 31.4858ZM232.813 62.6717L219.263 58.5847L211.907 82.974L225.456 87.061L232.813 62.6717ZM195.551 51.4321L217.231 57.9716L209.874 82.3609L188.194 75.8214L195.551 51.4321ZM175.906 45.5064L193.519 50.819L186.162 75.2084L168.549 69.8957L175.906 45.5064ZM152.194 38.3538L173.874 44.8933L166.517 69.2826L144.837 62.7431L152.194 38.3538ZM144.224 64.7756L136.867 89.1661L158.547 95.7057L165.904 71.3151L144.224 64.7756ZM167.936 71.9282L160.579 96.3187L178.192 101.631L185.549 77.2408L167.936 71.9282ZM187.581 77.8539L180.224 102.244L201.904 108.784L209.261 84.3934L187.581 77.8539ZM211.293 85.0065L203.936 109.397L217.486 113.484L224.843 89.0935L211.293 85.0065ZM136.254 91.1986L157.934 97.7381L152.825 114.675L131.145 108.136L136.254 91.1986ZM111.118 174.529L132.798 181.068L142.198 149.904L120.518 143.365L111.118 174.529ZM142.811 147.872L121.132 141.332L130.532 110.168L152.212 116.708L142.811 147.872ZM241.56 92.9944C241.922 91.7931 243.19 91.113 244.391 91.4754C245.593 91.8377 246.273 93.1053 245.91 94.3066C245.548 95.5079 244.28 96.188 243.079 95.8257C241.878 95.4633 241.198 94.1957 241.56 92.9944ZM279.19 101.973C277.988 101.611 276.721 102.291 276.358 103.492C275.996 104.693 276.676 105.961 277.878 106.323C279.079 106.686 280.346 106.006 280.709 104.804C281.071 103.603 280.391 102.336 279.19 101.973ZM233.502 119.693C233.864 118.492 235.132 117.812 236.333 118.174C237.534 118.537 238.214 119.804 237.852 121.005C237.49 122.207 236.222 122.887 235.021 122.524C233.82 122.162 233.139 120.895 233.502 119.693ZM271.136 128.672C269.935 128.309 268.667 128.989 268.305 130.191C267.943 131.392 268.623 132.66 269.824 133.022C271.025 133.384 272.293 132.704 272.655 131.503C273.018 130.302 272.338 129.034 271.136 128.672ZM249.605 66.3014C249.967 65.1001 251.235 64.42 252.436 64.7824C253.637 65.1447 254.317 66.4123 253.955 67.6136C253.593 68.8149 252.325 69.495 251.124 69.1327C249.923 68.7703 249.242 67.5027 249.605 66.3014ZM287.243 75.2799C286.042 74.9175 284.774 75.5976 284.412 76.7989C284.05 78.0002 284.73 79.2678 285.931 79.6301C287.132 79.9925 288.4 79.3124 288.762 78.1111C289.125 76.9098 288.444 75.6422 287.243 75.2799Z",
    fill: "#2E0249"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.91,
    y: 85.8402,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 228.91 85.8402)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.965,
    y: 59.1455,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 236.965 59.1455)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.867,
    y: 56.4017,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 227.867 56.4017)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.855,
    y: 112.537,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 220.855 112.537)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.039,
    y: 125.193,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 217.039 125.193)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.152,
    y: 132.768,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 242.152 132.768)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.438,
    y: 135.869,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 252.438 135.869)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.551,
    y: 138.017,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 259.551 138.017)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.637,
    y: 130.501,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 234.637 130.501)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.344,
    y: 127.698,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 225.344 127.698)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.941,
    y: 122.449,
    width: 8.26161,
    height: 6.19621,
    transform: "rotate(-73.2145 207.941 122.449)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.762,
    y: 109.794,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 211.762 109.794)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.66,
    y: 123.035,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 255.66 123.035)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.992,
    y: 85.7758,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 237.992 85.7758)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.043,
    y: 59.0811,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 246.043 59.0811)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.938,
    y: 112.47,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 229.938 112.47)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.34,
    y: 81.0951,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 230.34 81.0951)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.246,
    y: 78.3512,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 221.246 78.3512)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.391,
    y: 54.4004,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 238.391 54.4004)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.297,
    y: 51.6566,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 229.297 51.6566)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.289,
    y: 107.79,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 222.289 107.79)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.473,
    y: 120.445,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 218.473 120.445)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.582,
    y: 128.02,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 243.582 128.02)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.867,
    y: 131.122,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 253.867 131.122)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.09,
    y: 118.287,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 257.09 118.287)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.418,
    y: 81.0305,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 239.418 81.0305)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.477,
    y: 54.3331,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 247.477 54.3331)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.367,
    y: 107.725,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 231.367 107.725)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.773,
    y: 76.35,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 231.773 76.35)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.676,
    y: 73.6061,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 222.676 73.6061)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.824,
    y: 49.6553,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 239.824 49.6553)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.727,
    y: 46.9116,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 230.727 46.9116)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.719,
    y: 103.045,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 223.719 103.045)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.523,
    y: 113.543,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 258.523 113.543)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.852,
    y: 76.2827,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 240.852 76.2827)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.902,
    y: 49.5907,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 248.902 49.5907)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.801,
    y: 102.98,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 232.801 102.98)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.203,
    y: 71.6047,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 233.203 71.6047)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.109,
    y: 68.8612,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 224.109 68.8612)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.258,
    y: 44.9076,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 241.258 44.9076)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.152,
    y: 98.2994,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 225.152 98.2994)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.055,
    y: 95.5559,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 216.055 95.5559)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.953,
    y: 108.797,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 259.953 108.797)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.637,
    y: 66.8572,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 234.637 66.8572)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.691,
    y: 40.1625,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 242.691 40.1625)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.594,
    y: 37.4187,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 233.594 37.4187)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.586,
    y: 93.5519,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 226.586 93.5519)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.488,
    y: 90.808,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 217.488 90.808)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.285,
    y: 71.5378,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 242.285 71.5378)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.336,
    y: 44.8431,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 250.336 44.8431)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.234,
    y: 98.2325,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(-73.2145 234.234 98.2325)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.297,
    y: 122.021,
    width: 6.19621,
    height: 18.1756,
    transform: "rotate(-163.214 252.297 122.021)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.348,
    y: 95.324,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(-163.214 260.348 95.324)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.352,
    y: 56.7534,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(-163.214 263.352 56.7534)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.871,
    y: 88.193,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(-163.214 253.871 88.193)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.301,
    y: 83.448,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(-163.214 255.301 83.448)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.781,
    y: 90.5789,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(-163.214 261.781 90.5789)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.785,
    y: 52.0055,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(-163.214 264.785 52.0055)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.215,
    y: 85.8337,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(-163.214 263.215 85.8337)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.723,
    y: 49.4366,
    width: 13.9358,
    height: 3.15877,
    transform: "rotate(-163.214 273.723 49.4366)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.641,
    y: 81.0889,
    width: 6.19621,
    height: 8.26161,
    transform: "rotate(-163.214 264.641 81.0889)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.023,
    y: 103.036,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(-163.214 258.023 103.036)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.969,
    y: 115.755,
    width: 3.71773,
    height: 17.3494,
    transform: "rotate(-163.214 242.969 115.755)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.848,
    y: 31.4966,
    width: 6.19621,
    height: 10.9466,
    transform: "rotate(-163.214 241.848 31.4966)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.367,
    y: 31.4248,
    width: 35.7011,
    height: 2.0654,
    transform: "rotate(-140.796 227.367 31.4248)",
    fill: "#2E0249"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.316,
    y: 28.9907,
    width: 93.0242,
    height: 2.0654,
    transform: "rotate(-49.2602 243.316 28.9907)",
    fill: "#2E0249"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.203 -108.605L49.2355 -107.992L41.6741 -82.9249L56.5778 -78.4293L64.139 -103.496L66.1715 -102.883L58.6102 -77.8163L74.1931 -73.1158L81.7544 -98.1829L83.7869 -97.5698L76.2256 -72.5027L91.8084 -67.8023L99.3698 -92.8697L101.402 -92.2566L70.1354 11.399L83.6846 15.486L114.951 -88.1695L116.984 -87.5564L116.859 -87.1427L135.726 -71.2775L138.664 -81.0169L140.696 -80.4038L137.495 -69.7901L152.822 -56.9013L158.308 -75.0905L160.341 -74.4774L154.823 -56.1852L176.503 -49.6457L182.02 -67.9379L184.053 -67.3249L178.535 -49.0326L177.922 -47.0001L168.522 -15.8361L168.523 -15.8356L167.91 -13.8031L167.909 -13.8036L158.508 17.3602L158.512 17.3612L157.899 19.3937L157.895 19.3927L152.786 36.33L152.79 36.3311L152.177 38.3635L152.173 38.3625L144.816 62.753L144.816 62.753L144.203 64.7855L144.203 64.7855L136.846 89.1748L136.847 89.175L136.234 91.2075L136.233 91.2073L128.672 116.274L128.675 116.275L128.062 118.307L128.059 118.306L124.789 129.146L124.791 129.147L124.178 131.179L124.176 131.179L119.271 147.438L119.274 147.439L118.661 149.472L118.658 149.471L105.579 192.83L105.583 192.831L104.765 195.541L22.1116 170.609L22.9291 167.899L79.8348 185.064L89.2351 153.901L32.3287 136.735L20.0674 177.384L18.035 176.771L20.3054 169.244L-17.8539 137.155L-26.5242 146.486L3.05386 171.359L1.72456 172.94L-27.9319 148.001L-34.0645 154.601L-35.5776 153.195L-19.4366 135.824L-30.6051 126.433L-37.7784 134.152L-39.2914 132.747L-32.1878 125.102L-35.8015 122.063L-34.4722 120.482L-30.7802 123.587L-17.6983 109.508L-27.5012 101.265L-26.1719 99.6838L-16.2907 107.993L-3.1357 93.8356L-22.4016 77.6346L-21.0723 76.0538L-11.2166 84.3417L-8.99176 76.966L-18.2756 74.1656L-17.6625 72.1331L-8.37868 74.9335L-1.81551 53.1753C-3.18245 52.3525 -3.99205 50.8301 -3.90795 49.235L-10.3549 47.2903L-9.75843 45.3129L-3.31293 47.2572C-2.49526 45.8673 -0.95909 45.0421 0.650961 45.1275L6.26888 26.5031C4.8794 25.6844 4.05504 24.1474 4.14187 22.5369L-2.30277 20.5929L-1.70631 18.6155L4.73921 20.5598C5.5579 19.1719 7.0935 18.3485 8.70262 18.4347L14.3223 -0.195747C12.9341 -1.01365 12.11 -2.54861 12.1951 -4.15744L5.74934 -6.10175L6.34581 -8.07915L12.7904 -6.13519C13.6383 -7.57587 15.2582 -8.40961 16.932 -8.25111L47.203 -108.605ZM81.8673 185.677L103.547 192.217L116.626 148.858L94.9462 142.318L81.8673 185.677ZM126.026 117.693L122.757 128.533L101.077 121.994L104.347 111.154L126.026 117.693ZM86.1746 117.498L99.0445 121.381L102.314 110.541L45.4079 93.3752L41.138 107.531L71.4361 133.009L93.5268 139.673L98.4314 123.413L85.5615 119.531L86.1746 117.498ZM122.144 130.566L100.464 124.026L95.5593 140.286L117.239 146.825L122.144 130.566ZM70.548 134.959L92.9138 141.705L89.8482 151.868L32.9418 134.703L40.4886 109.684L66.4319 131.5L36.6207 122.507L36.0077 124.54L70.5438 134.957L70.5469 134.96L70.548 134.959ZM-6.42186 75.5238L0.134378 53.7886C1.76554 53.8994 3.32975 53.0731 4.15901 51.668L16.2361 55.311L8.75792 80.1026L-6.42186 75.5238ZM16.8326 53.3336L4.75677 49.691C4.84397 48.0797 4.01907 46.5418 2.6286 45.7232L8.24633 27.0994C9.8565 27.1853 11.393 26.3605 12.211 24.9708L24.289 28.6141L16.8326 53.3336ZM10.68 19.0313L16.2998 0.400559C17.9085 0.486427 19.4436 -0.336796 20.2622 -1.72415L32.3412 1.91939L24.8855 26.6367L12.8066 22.9932C12.8918 21.3844 12.0679 19.8494 10.68 19.0313ZM32.9377 -0.0580152L20.8598 -3.70122C20.9425 -5.23206 20.2019 -6.69663 18.9352 -7.54097L25.1211 -28.0486L40.0248 -23.553L32.9377 -0.0580152ZM-18.029 134.309L-29.1975 124.918L-16.1156 110.839L-4.94713 120.231L-18.029 134.309ZM-3.5395 118.716L-14.708 109.324L-1.55298 95.1665L9.61547 104.558L-3.5395 118.716ZM11.0231 103.043L-0.145351 93.6516L10.0279 82.7031L25.5675 87.3905L11.0231 103.043ZM-7.03494 77.5562L7.82572 82.0388L-1.72807 92.3207L-9.51366 85.7737L-7.03494 77.5562ZM11.1982 105.889L24.8833 117.397L26.2126 115.816L12.6058 104.374L27.7697 88.0548L43.3755 92.7621L30.9094 134.09L30.9072 134.089L30.2941 136.121L30.2963 136.122L20.9547 167.091L-16.4463 135.64L11.1982 105.889ZM106.846 -53.9471L116.21 -84.9901L135.076 -69.1249L125.713 -38.0819L106.846 -53.9471ZM127.481 -36.5945L136.845 -67.6376L152.138 -54.7773L152.205 -54.8563L142.809 -23.7057L127.481 -36.5945ZM142.19 -21.6563L142.127 -21.5806L126.832 -34.442L117.496 -3.49007L132.823 9.39874L142.19 -21.6563ZM125.063 -35.9293L106.197 -51.7945L96.8602 -20.8426L115.727 -4.97743L125.063 -35.9293ZM85.7171 16.0991L96.2109 -18.6901L115.078 -2.82484L107.397 22.6386L85.7171 16.0991ZM109.429 23.2517L116.846 -1.33748L132.141 11.5239L132.205 11.4482L127.042 28.5643L109.429 23.2517ZM25.7342 -30.081L40.6379 -25.5855L46.015 -43.4117L33.0451 -54.3182L25.7342 -30.081ZM42.0572 -22.9399L34.9702 0.555061L47.5938 4.36288C48.396 2.99968 49.8894 2.17986 51.4657 2.22982L57.6401 -18.2395L42.0572 -22.9399ZM53.5072 2.81308L59.6726 -17.6264L75.2554 -12.926L68.1029 10.7859L55.6445 7.02798C55.829 5.32335 54.9811 3.66605 53.5072 2.81308ZM54.907 9.02289C54.0584 10.2587 52.6134 10.979 51.1036 10.8985L45.4837 29.5298C46.8539 30.3381 47.674 31.8453 47.6116 33.4321L60.1326 37.209L67.4898 12.8184L54.907 9.02289ZM49.1261 10.3024L43.5065 28.9325C41.8968 28.8457 40.3605 29.6692 39.5415 31.0575L26.918 27.2497L34.3737 2.53247L46.9986 6.34065C46.9135 7.94956 47.7378 9.48457 49.1261 10.3024ZM47.0131 35.469L59.5195 39.2414L52.1627 63.6308L39.5645 59.8306C39.5212 58.353 38.719 56.9793 37.4324 56.2216L43.0503 37.5972C44.6597 37.6825 46.1953 36.8579 47.0131 35.469ZM35.4549 55.6256C33.8447 55.5399 32.3083 56.365 31.4904 57.755L18.8651 53.9466L26.3215 29.2271L38.9442 33.0347C38.8574 34.6457 39.6823 36.1832 41.0726 37.0016L35.4549 55.6256ZM30.8953 59.7328C30.8104 61.3407 31.6336 62.8747 33.0205 63.6929L26.4835 85.3643L28.4609 85.9608L34.9976 64.2903C36.7042 64.3823 38.3283 63.4512 39.1026 61.9087L51.5496 65.6632L43.9886 90.7296L10.7904 80.7157L18.2686 55.924L30.8953 59.7328ZM58.2532 -20.272L42.6703 -24.9724L47.7837 -41.9243L61.3447 -30.5208L58.2532 -20.272ZM60.2857 -19.6589L75.8685 -14.9585L76.6743 -17.6299L63.1134 -29.0334L60.2857 -19.6589ZM33.6944 -56.4708L41.061 -80.8924L55.9647 -76.3969L46.6643 -45.5643L33.6944 -56.4708ZM48.433 -44.0769L57.9972 -75.7838L73.58 -71.0833L61.994 -32.6734L48.433 -44.0769ZM63.7627 -31.186L75.6125 -70.4703L91.1953 -65.7698L77.3236 -19.7825L63.7627 -31.186ZM104.96 109.121L126.639 115.661L134.201 90.5942L112.521 84.0547L104.96 109.121ZM102.927 108.508L85.3149 103.195L92.8759 78.129L110.488 83.4416L102.927 108.508ZM83.2824 102.582L90.8435 77.5159L69.1638 70.9764L61.6027 96.0428L83.2824 102.582ZM59.5702 95.4297L46.021 91.3427L53.5821 66.2763L67.1313 70.3633L59.5702 95.4297ZM54.1952 64.2438L67.7444 68.3309L75.1012 43.9415L61.552 39.8545L54.1952 64.2438ZM91.4566 75.4834L69.7769 68.9439L77.1337 44.5546L98.8134 51.0941L91.4566 75.4834ZM111.101 81.4092L93.489 76.0965L100.846 51.7072L118.458 57.0198L111.101 81.4092ZM134.814 88.5617L113.134 82.0222L120.491 57.6329L142.17 64.1724L134.814 88.5617ZM142.784 62.1399L150.141 37.7494L128.461 31.2099L121.104 55.6004L142.784 62.1399ZM119.071 54.9874L126.429 30.5968L108.816 25.2841L101.459 49.6747L119.071 54.9874ZM99.4265 49.0616L106.784 24.6711L85.104 18.1316L77.7468 42.5221L99.4265 49.0616ZM75.7143 41.909L83.0715 17.5185L69.5223 13.4315L62.1651 37.822L75.7143 41.909ZM150.754 35.7169L129.074 29.1774L134.183 12.2401L155.863 18.7796L150.754 35.7169ZM175.89 -47.6132L154.21 -54.1527L144.81 -22.9887L166.489 -16.4492L175.89 -47.6132ZM144.197 -20.9562L165.876 -14.4167L156.476 16.7471L134.796 10.2076L144.197 -20.9562ZM45.4512 33.9204C45.0888 35.1217 43.8212 35.8018 42.6199 35.4394C41.4186 35.0771 40.7385 33.8095 41.1009 32.6082C41.4632 31.4069 42.7308 30.7268 43.9321 31.0892C45.1334 31.4515 45.8135 32.7191 45.4512 33.9204ZM7.81756 24.9414C9.01885 25.3038 10.2864 24.6237 10.6488 23.4224C11.0112 22.2211 10.3311 20.9535 9.12978 20.5912C7.92849 20.2288 6.66089 20.9089 6.29853 22.1102C5.93617 23.3115 6.61626 24.5791 7.81756 24.9414ZM53.5055 7.2219C53.1431 8.42319 51.8755 9.10328 50.6743 8.74092C49.473 8.37856 48.7929 7.11097 49.1552 5.90967C49.5176 4.70837 50.7852 4.02828 51.9865 4.39064C53.1878 4.753 53.8679 6.0206 53.5055 7.2219ZM15.871 -1.75709C17.0723 -1.39473 18.3399 -2.07483 18.7023 -3.27613C19.0646 -4.47742 18.3845 -5.74502 17.1832 -6.10738C15.9819 -6.46974 14.7143 -5.78964 14.352 -4.58835C13.9896 -3.38705 14.6697 -2.11945 15.871 -1.75709ZM37.4025 60.6137C37.0401 61.815 35.7725 62.4951 34.5712 62.1327C33.3699 61.7704 32.6899 60.5028 33.0522 59.3015C33.4146 58.1002 34.6822 57.4201 35.8835 57.7825C37.0848 58.1448 37.7649 59.4124 37.4025 60.6137ZM-0.231991 51.6347C0.969307 51.9971 2.2369 51.317 2.59926 50.1157C2.96163 48.9144 2.28153 47.6468 1.08023 47.2844C-0.121063 46.9221 -1.38866 47.6022 -1.75102 48.8035C-2.11338 50.0048 -1.43329 51.2723 -0.231991 51.6347Z",
    fill: "#2E0249"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0977,
    y: 41.0767,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 58.0977 41.0767)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2969,
    y: 30.5787,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 23.2969 30.5787)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2461,
    y: 57.2734,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 15.2461 57.2734)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.043,
    y: 67.7714,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 50.043 67.7714)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.1406,
    y: 70.5151,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 59.1406 70.5151)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1523,
    y: 14.3793,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 66.1523 14.3793)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9688,
    y: 1.724,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 69.9688 1.724)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.6641,
    y: -0.781128,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 61.6641 -0.781128)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.0664,
    y: 4.4679,
    width: 8.26161,
    height: 6.19621,
    transform: "rotate(106.786 79.0664 4.4679)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.2461,
    y: 17.123,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 75.2461 17.123)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.3477,
    y: 3.88159,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 31.3477 3.88159)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.0156,
    y: 41.1411,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 49.0156 41.1411)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.2188,
    y: 30.6433,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 14.2188 30.6433)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.16406,
    y: 57.3379,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 6.16406 57.3379)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.9648,
    y: 67.8358,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 40.9648 67.8358)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.0703,
    y: 14.4465,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 57.0703 14.4465)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2695,
    y: 3.94861,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 22.2695 3.94861)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.668,
    y: 45.8218,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 56.668 45.8218)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.7617,
    y: 48.5653,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 65.7617 48.5653)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.8633,
    y: 35.3239,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 21.8633 35.3239)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.8125,
    y: 62.0186,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 13.8125 62.0186)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.6172,
    y: 72.5162,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 48.6172 72.5162)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.7109,
    y: 75.26,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 57.7109 75.26)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.7188,
    y: 19.1271,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 64.7188 19.1271)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.5352,
    y: 6.47168,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 68.5352 6.47168)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.4258,
    y: -1.10339,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 43.4258 -1.10339)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.918,
    y: 8.62915,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 29.918 8.62915)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5898,
    y: 45.8864,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 47.5898 45.8864)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7852,
    y: 35.3884,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 12.7852 35.3884)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.73047,
    y: 62.0858,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 4.73047 62.0858)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5312,
    y: 72.5835,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 39.5312 72.5835)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.6406,
    y: 19.1917,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 55.6406 19.1917)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.8359,
    y: 8.69373,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 20.8359 8.69373)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2344,
    y: 50.5667,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 55.2344 50.5667)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.332,
    y: 53.3105,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 64.332 53.3105)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.4297,
    y: 40.0691,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 20.4297 40.0691)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3789,
    y: 66.7634,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 12.3789 66.7634)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.1836,
    y: 77.2614,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 47.1836 77.2614)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2812,
    y: 80.0052,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 56.2812 80.0052)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2891,
    y: 23.8719,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 63.2891 23.8719)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.4844,
    y: 13.3744,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 28.4844 13.3744)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.1562,
    y: 50.6339,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 46.1562 50.6339)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3516,
    y: 40.136,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 11.3516 40.136)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.30078,
    y: 66.8282,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 3.30078 66.8282)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.1055,
    y: 77.3259,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 38.1055 77.3259)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.207,
    y: 23.9365,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 54.207 23.9365)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.4023,
    y: 13.4388,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 19.4023 13.4388)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.8047,
    y: 55.3119,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 53.8047 55.3119)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.8984,
    y: 58.0557,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 62.8984 58.0557)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0039,
    y: 44.814,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 19.0039 44.814)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9453,
    y: 71.5114,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 10.9453 71.5114)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.75,
    y: 82.0093,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 45.75 82.0093)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8555,
    y: 28.6172,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 61.8555 28.6172)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.9531,
    y: 31.361,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 70.9531 31.361)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.0547,
    y: 18.1193,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 27.0547 18.1193)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3711,
    y: 60.0594,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 52.3711 60.0594)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5703,
    y: 49.5618,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 17.5703 49.5618)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.51953,
    y: 76.2562,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 9.51953 76.2562)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.3164,
    y: 86.7542,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 44.3164 86.7542)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.4141,
    y: 89.4979,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 53.4141 89.4979)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4258,
    y: 33.365,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 60.4258 33.365)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5195,
    y: 36.1086,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 69.5195 36.1086)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.6211,
    y: 22.8671,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 25.6211 22.8671)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.7227,
    y: 55.379,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 44.7227 55.379)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.91797,
    y: 44.8811,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 9.91797 44.8811)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.86719,
    y: 71.5758,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 1.86719 71.5758)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.6719,
    y: 82.0737,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 36.6719 82.0737)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7734,
    y: 28.6843,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 52.7734 28.6843)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.9727,
    y: 18.1865,
    width: 3.30465,
    height: 6.19621,
    transform: "rotate(106.786 17.9727 18.1865)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.7109,
    y: 4.89551,
    width: 6.19621,
    height: 18.1756,
    transform: "rotate(16.7855 34.7109 4.89551)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6602,
    y: 31.5929,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 26.6602 31.5929)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.6055,
    y: 58.2876,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 18.6055 58.2876)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.6523,
    y: 70.1636,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 23.6523 70.1636)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1328,
    y: 38.7236,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 33.1328 38.7236)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.64844,
    y: -0.763428,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 6.64844 -0.763428)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.40234,
    y: 25.9313,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 -1.40234 25.9313)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.707,
    y: 43.4689,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 31.707 43.4689)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.35156,
    y: 13.4745,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 2.35156 13.4745)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5.70312,
    y: 40.1692,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 -5.70312 40.1692)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.78125,
    y: 8.72668,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 3.78125 8.72668)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.26953,
    y: 35.4241,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 -4.26953 35.4241)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.2266,
    y: 36.3378,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 25.2266 36.3378)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.1758,
    y: 63.0325,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 17.1758 63.0325)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2227,
    y: 74.9111,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 22.2227 74.9111)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.793,
    y: 41.0829,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 23.793 41.0829)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.0078,
    y: 67.8198,
    width: 5.94593,
    height: 8.36146,
    transform: "rotate(16.7855 16.0078 67.8198)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2852,
    y: 77.4802,
    width: 13.9358,
    height: 3.15877,
    transform: "rotate(16.7855 13.2852 77.4802)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3633,
    y: 45.8281,
    width: 6.19621,
    height: 8.26161,
    transform: "rotate(16.7855 22.3633 45.8281)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.9844,
    y: 23.881,
    width: 6.19621,
    height: 3.30465,
    transform: "rotate(16.7855 28.9844 23.881)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.0391,
    y: 11.1624,
    width: 3.71773,
    height: 17.3494,
    transform: "rotate(16.7855 44.0391 11.1624)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.59766,
    y: 98.819,
    width: 4.54389,
    height: 5.16351,
    transform: "rotate(-46.6563 6.59766 98.819)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.08594,
    y: 104.475,
    width: 3.20484,
    height: 5.16351,
    transform: "rotate(-49.4182 2.08594 104.475)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.22656,
    y: 94.4426,
    width: 4.54389,
    height: 5.16351,
    transform: "rotate(-46.6563 1.22656 94.4426)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6562,
    y: 94.6536,
    width: 4.54389,
    height: 5.16351,
    transform: "rotate(-46.6563 10.6562 94.6536)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.28906,
    y: 90.2772,
    width: 4.54389,
    height: 5.16351,
    transform: "rotate(-46.6563 5.28906 90.2772)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.84375,
    y: 81.4069,
    width: 3.71773,
    height: 3.09811,
    transform: "rotate(16.7855 0.84375 81.4069)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.50781,
    y: 80.0947,
    width: 3.71773,
    height: 5.78313,
    transform: "rotate(16.7855 -3.50781 80.0947)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.7188,
    y: 90.4827,
    width: 2.28609,
    height: 5.16351,
    transform: "rotate(-46.6563 14.7188 90.4827)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.1602,
    y: 95.4203,
    width: 6.19621,
    height: 10.9466,
    transform: "rotate(16.7855 45.1602 95.4203)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.3672,
    y: 157.71,
    width: 6.19621,
    height: 3.51119,
    transform: "rotate(16.7855 26.3672 157.71)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7383,
    y: 153.16,
    width: 6.19621,
    height: 3.51119,
    transform: "rotate(16.7855 27.7383 153.16)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.1133,
    y: 148.611,
    width: 6.19621,
    height: 3.51119,
    transform: "rotate(16.7855 29.1133 148.611)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4844,
    y: 144.065,
    width: 6.19621,
    height: 3.51119,
    transform: "rotate(16.7855 30.4844 144.065)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8828,
    y: 131.072,
    width: 87.6148,
    height: 2.0654,
    transform: "rotate(39.2041 14.8828 131.072)",
    fill: "#2E0249"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6406,
    y: 95.4928,
    width: 35.7011,
    height: 2.0654,
    transform: "rotate(39.2041 59.6406 95.4928)",
    fill: "#2E0249"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6953,
    y: 97.9271,
    width: 93.0242,
    height: 2.0654,
    transform: "rotate(130.74 43.6953 97.9271)",
    fill: "#2E0249"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 115.241,
    cy: 147.241,
    r: 4.24145,
    fill: "#FE346E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.375,
    cy: 147.109,
    r: 1.98818,
    fill: "#FE346E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 25.5L32 30L40 32.5C40 32.5 41 29 44.5 30C47 31 46.5 34 46.5 34L119.023 56.201C119.559 56.3651 120.126 56.0565 120.278 55.5171L127.223 30.9778C127.375 30.4403 127.938 30.1317 128.473 30.2924L234 62L210.5 140.5L263.5 156.5",
    stroke: "#FE346E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.5 147.5L20.3377 168C20.8852 168.471 21.7361 168.224 21.9464 167.533L35.2083 123.958C35.3693 123.429 35.9291 123.131 36.4578 123.293L115.5 147.5",
    stroke: "#FE346E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5 180.5L171.432 127.626",
    stroke: "#FE346E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22L16.5 21.5H17.5H20H21L21.5 22.5L22 23.5L22.5 24.5L23 25.5L23.5 26.5V27.5V28L23 28.5H22L21.5 28L21 27H19L18.5 27.5L18 28L17.5 28.5H16.5L16 28V27V25.5V23.5V22Z",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7377 27.8182C18.501 28.5295 17.8569 28.9999 17.1196 29C16.391 29.0001 15.7495 28.5373 15.5122 27.8337C15.4865 27.7576 15.4499 27.7429 15.378 27.7434C14.8515 27.7467 15.1347 27.7467 14.6081 27.7457C14.5363 27.7456 14.4621 27.7439 14.393 27.7268C14.1481 27.6662 14.0003 27.4478 14 27.1445C13.9976 24.7941 15.3306 24.6363 15.4367 22.5859C15.4378 22.3434 15.4687 22.0977 15.5162 21.8597C15.5995 21.4424 15.8326 21.1435 16.2655 21.049C16.4183 21.0156 16.5783 21.0023 16.7349 21.0021C18.9662 20.9992 16.3856 21.0001 18.6169 21.0002C20.371 21.0002 18.5105 21.0007 20.2646 21C20.6943 20.9998 21.0597 21.1502 21.3608 21.4586C21.6117 21.7154 22.5075 23.2305 22.6915 23.5342C23.162 24.3109 24.8175 23.6392 25.7538 25.2367C25.9887 25.8082 26.031 26.3872 25.9818 27.1559C25.9551 27.5731 25.781 27.739 25.3624 27.7395C24.9609 27.7401 24.5593 27.7438 24.1579 27.7368C24.0575 27.735 24.0217 27.7673 23.9876 27.8597C23.7672 28.4562 23.3442 28.8386 22.7238 28.9621C22.0842 29.0895 21.5357 28.8932 21.0986 28.4023C20.9295 28.2124 20.8202 27.9882 20.7464 27.7442C19.2292 27.7442 20.2832 27.7442 18.7645 27.7442C18.7534 27.7749 18.745 27.7964 18.7377 27.8182ZM17.9292 23.7296C18.8049 23.9026 20.454 24.1736 21.3726 24.1736C22.106 24.1736 21.9007 23.7256 21.6698 23.2194C21.1658 22.4663 21.1532 22.3861 20.9164 22.0834C20.7133 21.8237 20.4525 21.6878 20.1167 21.6903C19.4225 21.6957 18.7281 21.6919 18.0338 21.6919C18.0016 21.6919 17.9694 21.6919 17.9292 21.6919C17.9292 22.3801 17.9292 23.0532 17.9292 23.7296ZM17.555 21.6919C17.5159 21.6919 17.4809 21.6919 17.4459 21.6919C16.7289 21.6919 17.4467 21.6918 16.7298 21.6923C16.674 21.6923 16.6172 21.6908 16.5625 21.7002C16.3203 21.7416 16.1869 21.8872 16.1665 22.1812C16.1421 22.5328 16.1421 22.5261 16.1338 22.8788C16.1313 22.9843 16.1355 23.09 16.1383 23.1956C16.1407 23.2866 16.2002 23.2912 16.2794 23.3379C16.648 23.5553 16.7741 23.6231 17.5282 23.6963C17.5341 23.6963 17.54 23.6921 17.5549 23.6865C17.5549 23.0235 17.555 22.3641 17.555 21.6919ZM21.4429 27.313C21.4482 27.8263 21.8737 28.2431 22.3903 28.2413C22.9152 28.2395 23.339 27.8129 23.3365 27.2888C23.334 26.7656 22.8762 26.341 22.3536 26.3458C21.8228 26.3507 21.4373 26.7765 21.4429 27.313ZM18.0663 27.2767C18.0613 26.7581 17.6328 26.3404 17.1114 26.3459C16.5871 26.3513 16.1658 26.782 16.1727 27.3055C16.1795 27.8247 16.6079 28.2457 17.1253 28.2416C17.6563 28.2374 18.0715 27.8117 18.0663 27.2767Z",
    fill: "#FE346E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 123L168.5 122.5H169.5H172H173L173.5 123.5L174 124.5L174.5 125.5L175 126.5L175.5 127.5V128.5V129L175 129.5H174L173.5 129L173 128H171L170.5 128.5L170 129L169.5 129.5H168.5L168 129V128V126.5V124.5V123Z",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.738 128.818C170.501 129.529 169.857 130 169.12 130C168.391 130 167.75 129.537 167.512 128.834C167.486 128.758 167.45 128.743 167.378 128.743C166.851 128.747 167.135 128.747 166.608 128.746C166.536 128.746 166.462 128.744 166.393 128.727C166.148 128.666 166 128.448 166 128.145C165.998 125.794 167.331 125.636 167.437 123.586C167.438 123.343 167.469 123.098 167.516 122.86C167.599 122.442 167.833 122.143 168.266 122.049C168.418 122.016 168.578 122.002 168.735 122.002C170.966 121.999 168.386 122 170.617 122C172.371 122 170.511 122.001 172.265 122C172.694 122 173.06 122.15 173.361 122.459C173.612 122.715 174.507 124.231 174.691 124.534C175.162 125.311 176.818 124.639 177.754 126.237C177.989 126.808 178.031 127.387 177.982 128.156C177.955 128.573 177.781 128.739 177.362 128.74C176.961 128.74 176.559 128.744 176.158 128.737C176.057 128.735 176.022 128.767 175.988 128.86C175.767 129.456 175.344 129.839 174.724 129.962C174.084 130.089 173.536 129.893 173.099 129.402C172.93 129.212 172.82 128.988 172.746 128.744C171.229 128.744 172.283 128.744 170.765 128.744C170.753 128.775 170.745 128.796 170.738 128.818ZM169.929 124.73C170.805 124.903 172.454 125.174 173.373 125.174C174.106 125.174 173.901 124.726 173.67 124.219C173.166 123.466 173.153 123.386 172.916 123.083C172.713 122.824 172.453 122.688 172.117 122.69C171.422 122.696 170.728 122.692 170.034 122.692C170.002 122.692 169.969 122.692 169.929 122.692C169.929 123.38 169.929 124.053 169.929 124.73ZM169.555 122.692C169.516 122.692 169.481 122.692 169.446 122.692C168.729 122.692 169.447 122.692 168.73 122.692C168.674 122.692 168.617 122.691 168.563 122.7C168.32 122.742 168.187 122.887 168.166 123.181C168.142 123.533 168.142 123.526 168.134 123.879C168.131 123.984 168.136 124.09 168.138 124.196C168.141 124.287 168.2 124.291 168.279 124.338C168.648 124.555 168.774 124.623 169.528 124.696C169.534 124.696 169.54 124.692 169.555 124.686C169.555 124.023 169.555 123.364 169.555 122.692ZM173.443 128.313C173.448 128.826 173.874 129.243 174.39 129.241C174.915 129.239 175.339 128.813 175.336 128.289C175.334 127.766 174.876 127.341 174.354 127.346C173.823 127.351 173.437 127.777 173.443 128.313ZM170.066 128.277C170.061 127.758 169.633 127.34 169.111 127.346C168.587 127.351 168.166 127.782 168.173 128.305C168.18 128.825 168.608 129.246 169.125 129.242C169.656 129.237 170.072 128.812 170.066 128.277Z",
    fill: "#FE346E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_512_35117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 179,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentcarPicture);
export default __webpack_public_path__ + "static/media/rentcarPicture.fd0446bd5352d1ccbc0a8fe0133f445d.svg";
export { ForwardRef as ReactComponent };